import type { AppRoutesState } from '@modules/store/common/types/AppRoutesState.entity';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import { ActionTree } from 'vuex';

export const actions: ActionTree<AppRoutesState, CommonState> = {};
